import { useEffect, useRef } from "react";
import gsap from "gsap";

const fmt = (n) => Math.round(n).toLocaleString("en-IN");

/** Counts from `from` to `to` (INR formatted) whenever `run` flips true. */
const CountUp = ({ to, from = 0, run = true, prefix = "₹", duration = 1.2 }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (!run) {
      el.textContent = prefix + fmt(from);
      return undefined;
    }
    const o = { v: from };
    const tw = gsap.to(o, { v: to, duration, ease: "power3.out", onUpdate: () => (el.textContent = prefix + fmt(o.v)) });
    return () => tw.kill();
  }, [run, to, from, prefix, duration]);
  return <span ref={ref}>{prefix + fmt(to)}</span>;
};

export default CountUp;
